module.exports = __webpack_public_path__ + "img/edit.b72c4a6f.svg";